import { BaseAction } from "../../../core/actions/BaseAction";
import { _eventBus } from "../../../core/events/EventBus";
import { updateRecoilState } from "../../../Orchestrator/Recoils/Events/Recoil";
import { IGetDestinationActionParams } from "../../../Orchestrator/Types/Interface/ICmsDestination";

class DestinationReadMoreClickAction extends BaseAction<void, IGetDestinationActionParams> {
    override async run(): Promise<void> {
        updateRecoilState("cmsPLaceDetailAtom", null);
        const { slug } = this.params!;
        _eventBus.emit({
            eventName: "ROUTE_CHANGE",
            data: `/destinations/${slug}`,
        })
    }
}

export const destinationReadMoreClickAction = new DestinationReadMoreClickAction();
